// removed by extract-text-webpack-plugin
module.exports = {"error":"BatchSentItemsRow__error___qxyyX","in-progress":"BatchSentItemsRow__in-progress___1Ohto"};